import { toAccountId } from '@atlassian/jira-shared-types/src/general.tsx';
import { ASSIGNEE_TYPE_PROJECT_LEAD } from '../../model/constants';
import {
	FETCH_PROJECT_DETAILS,
	FETCH_PROJECT_DETAILS_SUCCESS,
	FETCH_PROJECT_DETAILS_FAIL,
	SAVE_PROJECT_DETAILS,
	SAVE_ALL_PROJECT_DETAILS,
	SAVE_PROJECT_DETAILS_SUCCESS,
	SAVE_PROJECT_DETAILS_FAIL,
	SAVE_ALL_PROJECT_DETAILS_SUCCESS,
	RELOAD_ON_REFRESH,
	FETCH_PROJECT_CATEGORIES_SUCCESS,
	FETCH_PROJECT_CATEGORIES,
	FETCH_PROJECT_CATEGORIES_FAIL,
	type ProjectDetailsEntitiesAction,
	FETCH_INSTANCE_PROPERTIES_FAIL,
	FETCH_INSTANCE_PROPERTIES_SUCCESS,
	FETCH_INSTANCE_PROPERTIES,
} from './actions';
import type { EntitiesState } from './types';

export const entitiesInitialState: EntitiesState = {
	projectName: '',
	projectKey: '',
	projectUrl: '',
	projectDescription: '',
	simplified: false,
	avatar: undefined,
	predefinedAvatars: [],
	hasFetchDataError: false,
	projectCategoryId: undefined,
	projectLeadAccountId: toAccountId(''),
	allProjectCategories: [],
	hasFetchAvatarError: false,
	assigneeType: ASSIGNEE_TYPE_PROJECT_LEAD,
	projectTeamType: undefined,
	projectTeamTypeFreeText: undefined,
	historicalProjectKeys: [],
};

type Action = ProjectDetailsEntitiesAction;

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default (state: EntitiesState = entitiesInitialState, action: Action): EntitiesState => {
	switch (action.type) {
		case SAVE_PROJECT_DETAILS_SUCCESS:
		case FETCH_PROJECT_DETAILS_SUCCESS: {
			const {
				name,
				key,
				url,
				avatar,
				predefinedAvatars,
				projectCategoryId,
				projectLeadAccountId,
				assigneeType,
				hasFetchAvatarError,
				description,
				simplified,
				projectTeamType,
				projectTeamTypeFreeText,
				historicalProjectKeys,
			} = action.payload;
			return {
				...state,
				projectName: name,
				projectKey: key,
				projectUrl: url,
				projectDescription: description,
				simplified,
				avatar,
				predefinedAvatars,
				projectCategoryId,
				projectLeadAccountId,
				assigneeType,
				hasFetchAvatarError,
				projectTeamType,
				projectTeamTypeFreeText,
				historicalProjectKeys,
			};
		}
		case SAVE_ALL_PROJECT_DETAILS_SUCCESS: {
			const {
				name,
				key,
				avatar,
				projectCategoryId,
				url,
				description,
				simplified,
				historicalProjectKeys,
			} = action.payload;
			return {
				...state,
				projectName: name,
				projectKey: key,
				projectUrl: url,
				projectDescription: description,
				simplified,
				avatar,
				projectCategoryId,
				historicalProjectKeys,
			};
		}

		case FETCH_PROJECT_DETAILS_FAIL: {
			return {
				...state,
				hasFetchDataError: true,
			};
		}
		case FETCH_PROJECT_DETAILS:
		case SAVE_PROJECT_DETAILS:
		case SAVE_PROJECT_DETAILS_FAIL:
		case SAVE_ALL_PROJECT_DETAILS:
		case FETCH_PROJECT_CATEGORIES:
		case FETCH_PROJECT_CATEGORIES_FAIL:
		case FETCH_INSTANCE_PROPERTIES:
		case FETCH_INSTANCE_PROPERTIES_FAIL:
		case FETCH_INSTANCE_PROPERTIES_SUCCESS:
		case RELOAD_ON_REFRESH: {
			return state;
		}
		case FETCH_PROJECT_CATEGORIES_SUCCESS:
			return {
				...state,
				allProjectCategories: action.payload,
			};
		default: {
			const _exhaustiveCheck: never = action;

			return state;
		}
	}
};
